import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  basepath: import.meta.env.BASE_URL,
  defaultPreload: 'intent',
  // The host 301s every `/x` to `/x/`, so render links in that form — crawlers
  // that run JS would otherwise follow a redirect on every internal link.
  trailingSlash: 'always',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
